import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	title: {
		id: 'snippets.privateTemplateCopyLinkModal.title',
		defaultMessage: 'This template is set to private',
		description: 'Title for the modal shown when user tries to copy link for a private template',
	},
	body: {
		id: 'snippets.privateTemplateCopyLinkModal.body',
		defaultMessage: 'If you want to share this template you must set it to public.',
		description:
			'Body text explaining that the user must set the template to public to share via link',
	},
	cancelButton: {
		id: 'snippets.privateTemplateCopyLinkModal.cancelButton',
		defaultMessage: 'Cancel',
		description: 'Cancel button for the private template copy link modal',
	},
	editTemplateSettingsButton: {
		id: 'snippets.privateTemplateCopyLinkModal.editTemplateSettingsButton',
		defaultMessage: 'Edit template settings',
		description: 'Primary button that opens the edit modal for the template',
	},
});
